module.exports = __webpack_public_path__ + "img/150.80366099.jpg";